<template>
  <div style="overflow: auto; max-width: 960px" class="mx-auto py-12">
    <div v-for="(job, index) in jobs" :key="index">
      <JobOffer class="mb-12" :isTopPage="isTopPage" :job="job"/>
    </div>
  </div>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import ApiMixin from "../../ApiMixin";
  import {mapGetters} from "vuex";
  import JobOffer from "../molecules/JobOffer"

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "organism",
    name: "JobOffersList",
    props: {
      jobs: {
        type: Array,
        required: true
      },
      isTopPage: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      JobOffer,
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style scoped lang="sass">
  .settingIcon
    position: absolute
    right: 8px
    top: 8px

  .logo_icon
    border-radius: 50%

  .job_link:hover
    color: #7aabcc

  .jobTag
    color: black
    font-size: 14px
    line-height: 20px
    text-align: center
    background-color: #FFE3BA
    max-width: 60px
    height: 20px
    margin-bottom: 10px

  .jobTag.side
    background-color: #BAFFD6

  .jobTitle
    color: #2f3e6d
    font-size: 18px

  .jobProperty
    color: #2f3e6d
    font-size: 14px

  .inline-box
    display: inline-block
    line-height: 24px

  .jobDetail
    color: #2f3e6d
    font-size: 14px
    margin-top: 2px
</style>
